/** A product's icon: its image when it has one, otherwise its initials. */
export default function ProductIcon({ name, src, className = 'w-8 h-8 rounded-md' }: { name: string; src?: string; className?: string }) {
  if (src) return <img src={src} alt={name} className={className} />
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? '').join('') || '?'
  return (
    <div className={`${className} bg-primary/10 text-primary font-semibold flex items-center justify-center text-xs`} aria-hidden="true">
      {initials}
    </div>
  )
}
